import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const UserAttendanceRoutes = defineRoute({
    home: {
        route: {
            path: "/user-attendance",
            component: () => loadView(import("./UserAttendanceHome.vue")),
        },
    },
});
